import "tailwindcss/dist/base.css";
import "styles/globalStyles.css";
import React from "react";
import { css } from "styled-components/macro"; //eslint-disable-line

/*
 * This is the entry point component of this project. You can change the below exported default App component to any of
 * the prebuilt landing page components by uncommenting their import and export lines respectively.
 * See one of the landing page components to better understand how to import and render different components (Always
 * make sure if you are building your own page, the root component should be the AnimationRevealPage component. You can
 * disable the animation by using the disabled prop.
 *
 * The App component below is using React router to render the landing page that you see on the live demo website
 * and the component previews.
 *
 */

/* Use AnimationRevealPage as a wrapper component for your pages if you are building a custom one yourself */
// import AnimationRevealPage from "helpers/AnimationRevealPage.js";

/*
 * Hero section is the top most section on the page. It contains the header as well.
 * So you dont need to import headers
 * separately
 */

import MainPage from "MainPage.js";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { RecoilRoot } from "recoil";
import LaunchApplicationPage from "pages/LaunchApplication";
import DownloadPage from "pages/Download";
import SctaGuidelinesPage from "pages/SctaGuidlines";
import SalesforceIntegrationOAuthCallback from "pages/SalesforceIntegrationOAuthCallback";
import NotionIntegrationOAuthCallback from "pages/NotionIntegrationOAuthCallback";

export default function App() {
  return (
    <RecoilRoot>
    <Router>
        <Routes>
          <Route path="/launch/:fileId" element={<LaunchApplicationPage />} />
          <Route path="/download" element={<DownloadPage />} />
          <Route path="/scta" element={<SctaGuidelinesPage />} />
          <Route path="/integration/salesforce/oauth2/callback" element={<SalesforceIntegrationOAuthCallback />} />
          <Route path="/integration/notion/oauth2/callback" element={<NotionIntegrationOAuthCallback />} />
          <Route path="/" element={<MainPage />} />
        </Routes>
    </Router>
    </RecoilRoot>
  );
}
